// Single source of truth for the group hierarchy + KPIs across all slivers.
// Aggregated values (country / region / group) are derivable but we materialise
// them here for display stability.

const branch = (id, name, town, region, country, peerGroup, overrides = {}) => ({
  id, name, town, region, country, peerGroup,
  ops: {
    slaAdherence: 92.4, avgTurnaroundMin: 48, firstTimeFix: 94.1,
    jobsToday: 38, jobsMTD: 812, technicianUtil: 84, reworkRate: 2.3,
    openJobs: 14, breachedSlaCount: 1,
  },
  hr: {
    headcount: 24, vacancies: 1, absenteeism: 3.1, overtimeHrs: 112,
    trainingComplete: 91, disciplinaryOpen: 0, turnoverYTD: 6.2, engagementScore: 7.8,
    ltifr: 0.8,
  },
  finance: {
    revenueToday: 142000, revenueMTD: 3380000, gpPct: 41.2, ebitdaPct: 18.6,
    debtorsDays: 34, costPerJob: 1820, roiBranch: 23.4, cashCollected: 128000,
  },
  iso: {
    complianceScore: 99.4, ncrOpen: 2, ncrOverdue: 0, capaEffectiveness: 96,
    auditCoverage: 88, docControlScore: 99, externalFindings: 0, evidenceCompleteness: 98,
  },
  compliance: {
    popiaIncidents: 0, safetyNearMisses: 3, ppeCompliance: 98, toolboxTalkCompletion: 96,
    legalDisputesOpen: 0, envScore: 94, insurerAuditPass: 100,
  },
  supply: {
    stockAvailability: 96.2, stockoutEvents: 1, stockTurnDays: 18,
    shrinkagePct: 0.6, difotSuppliers: 94, openPOs: 12, criticalLowItems: 3,
  },
  sales: {
    quotesIssued: 54, quoteConversion: 62, avgJobValue: 4680, insurerMix: 78,
    contractComplianceScore: 97, npsBranch: 9.2, repeatCustomerPct: 28,
    pipelineValue: 1840000,
  },
  cx: {
    nps: 9.2, csat: 94, complaintOpen: 2, complaintResolutionHrs: 18,
    closedLoopPct: 97, responseRate: 62,
  },
  ...overrides,
});

export const BRANCHES = [
  // Gauteng
  branch('sandton-cbd', 'Sandton CBD', 'Johannesburg', 'Gauteng', 'South Africa', 'Metro-Flagship', {
    ops: { slaAdherence: 98.1, avgTurnaroundMin: 44, firstTimeFix: 97.2, jobsToday: 52, jobsMTD: 1140, technicianUtil: 92, reworkRate: 1.2, openJobs: 18, breachedSlaCount: 0 },
    finance: { revenueToday: 248000, revenueMTD: 5820000, gpPct: 44.8, ebitdaPct: 22.1, debtorsDays: 28, costPerJob: 1680, roiBranch: 31.2, cashCollected: 238000 },
    cx: { nps: 9.8, csat: 97, complaintOpen: 1, complaintResolutionHrs: 12, closedLoopPct: 99, responseRate: 71 },
    iso: { complianceScore: 99.8, ncrOpen: 1, ncrOverdue: 0, capaEffectiveness: 98, auditCoverage: 95, docControlScore: 100, externalFindings: 0, evidenceCompleteness: 99 },
  }),
  branch('midrand', 'Midrand', 'Johannesburg', 'Gauteng', 'South Africa', 'Metro-Standard'),
  branch('centurion', 'Centurion', 'Pretoria', 'Gauteng', 'South Africa', 'Metro-Standard', {
    ops: { slaAdherence: 88.2, avgTurnaroundMin: 56, firstTimeFix: 90.1, jobsToday: 31, jobsMTD: 702, technicianUtil: 78, reworkRate: 3.8, openJobs: 22, breachedSlaCount: 4 },
    cx: { nps: 7.9, csat: 86, complaintOpen: 6, complaintResolutionHrs: 36, closedLoopPct: 82, responseRate: 48 },
  }),
  branch('pretoria-east', 'Pretoria East', 'Pretoria', 'Gauteng', 'South Africa', 'Metro-Standard'),
  branch('roodepoort', 'Roodepoort', 'Johannesburg', 'Gauteng', 'South Africa', 'Metro-Standard'),

  // Western Cape
  branch('cape-town-cbd', 'Cape Town CBD', 'Cape Town', 'Western Cape', 'South Africa', 'Metro-Flagship', {
    ops: { slaAdherence: 96.4, avgTurnaroundMin: 46, firstTimeFix: 95.8, jobsToday: 44, jobsMTD: 978, technicianUtil: 89, reworkRate: 1.8, openJobs: 16, breachedSlaCount: 0 },
    finance: { revenueToday: 198000, revenueMTD: 4620000, gpPct: 43.1, ebitdaPct: 20.4, debtorsDays: 30, costPerJob: 1720, roiBranch: 28.4, cashCollected: 188000 },
  }),
  branch('bellville', 'Bellville', 'Cape Town', 'Western Cape', 'South Africa', 'Metro-Standard'),
  branch('somerset-west', 'Somerset West', 'Cape Town', 'Western Cape', 'South Africa', 'Metro-Standard'),
  branch('george', 'George', 'George', 'Western Cape', 'South Africa', 'Regional-Town'),

  // KZN
  branch('durban-cbd', 'Durban CBD', 'Durban', 'KwaZulu-Natal', 'South Africa', 'Metro-Flagship'),
  branch('umhlanga', 'Umhlanga', 'Durban', 'KwaZulu-Natal', 'South Africa', 'Metro-Standard'),
  branch('pietermaritzburg', 'Pietermaritzburg', 'Pietermaritzburg', 'KwaZulu-Natal', 'South Africa', 'Regional-Town', {
    ops: { slaAdherence: 84.1, avgTurnaroundMin: 62, firstTimeFix: 87.2, jobsToday: 22, jobsMTD: 498, technicianUtil: 71, reworkRate: 4.6, openJobs: 19, breachedSlaCount: 5 },
    hr: { headcount: 18, vacancies: 3, absenteeism: 5.4, overtimeHrs: 168, trainingComplete: 74, disciplinaryOpen: 2, turnoverYTD: 12.1, engagementScore: 6.2, ltifr: 2.1 },
  }),

  // Eastern Cape
  branch('port-elizabeth', 'Gqeberha', 'Gqeberha', 'Eastern Cape', 'South Africa', 'Regional-Town'),
  branch('east-london', 'East London', 'East London', 'Eastern Cape', 'South Africa', 'Regional-Town'),

  // Rest of Africa
  branch('windhoek', 'Windhoek', 'Windhoek', 'Khomas', 'Namibia', 'Africa-Metro'),
  branch('gaborone', 'Gaborone', 'Gaborone', 'South-East', 'Botswana', 'Africa-Metro'),
  branch('maputo', 'Maputo', 'Maputo', 'Maputo', 'Mozambique', 'Africa-Metro', {
    ops: { slaAdherence: 81.2, avgTurnaroundMin: 68, firstTimeFix: 85.4, jobsToday: 19, jobsMTD: 412, technicianUtil: 69, reworkRate: 5.1, openJobs: 21, breachedSlaCount: 6 },
  }),
  branch('harare', 'Harare', 'Harare', 'Harare', 'Zimbabwe', 'Africa-Metro'),
  branch('lusaka', 'Lusaka', 'Lusaka', 'Lusaka', 'Zambia', 'Africa-Metro'),
  branch('nairobi', 'Nairobi', 'Nairobi', 'Nairobi', 'Kenya', 'Africa-Metro'),
];

// ---------- Aggregation ----------
const avg = (xs) => xs.reduce((a, b) => a + b, 0) / xs.length;
const sum = (xs) => xs.reduce((a, b) => a + b, 0);

function rollup(branches) {
  return {
    ops: {
      slaAdherence: +avg(branches.map(b => b.ops.slaAdherence)).toFixed(1),
      avgTurnaroundMin: Math.round(avg(branches.map(b => b.ops.avgTurnaroundMin))),
      firstTimeFix: +avg(branches.map(b => b.ops.firstTimeFix)).toFixed(1),
      jobsToday: sum(branches.map(b => b.ops.jobsToday)),
      jobsMTD: sum(branches.map(b => b.ops.jobsMTD)),
      technicianUtil: Math.round(avg(branches.map(b => b.ops.technicianUtil))),
      reworkRate: +avg(branches.map(b => b.ops.reworkRate)).toFixed(1),
      openJobs: sum(branches.map(b => b.ops.openJobs)),
      breachedSlaCount: sum(branches.map(b => b.ops.breachedSlaCount)),
    },
    hr: {
      headcount: sum(branches.map(b => b.hr.headcount)),
      vacancies: sum(branches.map(b => b.hr.vacancies)),
      absenteeism: +avg(branches.map(b => b.hr.absenteeism)).toFixed(1),
      overtimeHrs: sum(branches.map(b => b.hr.overtimeHrs)),
      trainingComplete: Math.round(avg(branches.map(b => b.hr.trainingComplete))),
      disciplinaryOpen: sum(branches.map(b => b.hr.disciplinaryOpen)),
      turnoverYTD: +avg(branches.map(b => b.hr.turnoverYTD)).toFixed(1),
      engagementScore: +avg(branches.map(b => b.hr.engagementScore)).toFixed(1),
      ltifr: +avg(branches.map(b => b.hr.ltifr)).toFixed(1),
    },
    finance: {
      revenueToday: sum(branches.map(b => b.finance.revenueToday)),
      revenueMTD: sum(branches.map(b => b.finance.revenueMTD)),
      gpPct: +avg(branches.map(b => b.finance.gpPct)).toFixed(1),
      ebitdaPct: +avg(branches.map(b => b.finance.ebitdaPct)).toFixed(1),
      debtorsDays: Math.round(avg(branches.map(b => b.finance.debtorsDays))),
      costPerJob: Math.round(avg(branches.map(b => b.finance.costPerJob))),
      roiBranch: +avg(branches.map(b => b.finance.roiBranch)).toFixed(1),
      cashCollected: sum(branches.map(b => b.finance.cashCollected)),
    },
    iso: {
      complianceScore: +avg(branches.map(b => b.iso.complianceScore)).toFixed(1),
      ncrOpen: sum(branches.map(b => b.iso.ncrOpen)),
      ncrOverdue: sum(branches.map(b => b.iso.ncrOverdue)),
      capaEffectiveness: Math.round(avg(branches.map(b => b.iso.capaEffectiveness))),
      auditCoverage: Math.round(avg(branches.map(b => b.iso.auditCoverage))),
      docControlScore: Math.round(avg(branches.map(b => b.iso.docControlScore))),
      externalFindings: sum(branches.map(b => b.iso.externalFindings)),
      evidenceCompleteness: Math.round(avg(branches.map(b => b.iso.evidenceCompleteness))),
    },
    compliance: {
      popiaIncidents: sum(branches.map(b => b.compliance.popiaIncidents)),
      safetyNearMisses: sum(branches.map(b => b.compliance.safetyNearMisses)),
      ppeCompliance: Math.round(avg(branches.map(b => b.compliance.ppeCompliance))),
      toolboxTalkCompletion: Math.round(avg(branches.map(b => b.compliance.toolboxTalkCompletion))),
      legalDisputesOpen: sum(branches.map(b => b.compliance.legalDisputesOpen)),
      envScore: Math.round(avg(branches.map(b => b.compliance.envScore))),
      insurerAuditPass: Math.round(avg(branches.map(b => b.compliance.insurerAuditPass))),
    },
    supply: {
      stockAvailability: +avg(branches.map(b => b.supply.stockAvailability)).toFixed(1),
      stockoutEvents: sum(branches.map(b => b.supply.stockoutEvents)),
      stockTurnDays: Math.round(avg(branches.map(b => b.supply.stockTurnDays))),
      shrinkagePct: +avg(branches.map(b => b.supply.shrinkagePct)).toFixed(2),
      difotSuppliers: Math.round(avg(branches.map(b => b.supply.difotSuppliers))),
      openPOs: sum(branches.map(b => b.supply.openPOs)),
      criticalLowItems: sum(branches.map(b => b.supply.criticalLowItems)),
    },
    sales: {
      quotesIssued: sum(branches.map(b => b.sales.quotesIssued)),
      quoteConversion: Math.round(avg(branches.map(b => b.sales.quoteConversion))),
      avgJobValue: Math.round(avg(branches.map(b => b.sales.avgJobValue))),
      insurerMix: Math.round(avg(branches.map(b => b.sales.insurerMix))),
      contractComplianceScore: Math.round(avg(branches.map(b => b.sales.contractComplianceScore))),
      npsBranch: +avg(branches.map(b => b.sales.npsBranch)).toFixed(1),
      repeatCustomerPct: Math.round(avg(branches.map(b => b.sales.repeatCustomerPct))),
      pipelineValue: sum(branches.map(b => b.sales.pipelineValue)),
    },
    cx: {
      nps: +avg(branches.map(b => b.cx.nps)).toFixed(1),
      csat: Math.round(avg(branches.map(b => b.cx.csat))),
      complaintOpen: sum(branches.map(b => b.cx.complaintOpen)),
      complaintResolutionHrs: Math.round(avg(branches.map(b => b.cx.complaintResolutionHrs))),
      closedLoopPct: Math.round(avg(branches.map(b => b.cx.closedLoopPct))),
      responseRate: Math.round(avg(branches.map(b => b.cx.responseRate))),
    },
  };
}

export const GROUP = { id: 'group', name: 'PG Glass Africa', kpis: rollup(BRANCHES) };

export const COUNTRIES = [...new Set(BRANCHES.map(b => b.country))].map(country => {
  const kids = BRANCHES.filter(b => b.country === country);
  return { id: country.toLowerCase().replace(/\s+/g, '-'), name: country, branches: kids, kpis: rollup(kids) };
});

export const REGIONS = [...new Set(BRANCHES.map(b => `${b.country}::${b.region}`))].map(key => {
  const [country, region] = key.split('::');
  const kids = BRANCHES.filter(b => b.country === country && b.region === region);
  return {
    id: `${country}-${region}`.toLowerCase().replace(/\s+/g, '-'),
    name: region, country,
    branches: kids, kpis: rollup(kids),
  };
});

export const TOWNS = [...new Set(BRANCHES.map(b => `${b.country}::${b.region}::${b.town}`))].map(key => {
  const [country, region, town] = key.split('::');
  const kids = BRANCHES.filter(b => b.country === country && b.region === region && b.town === town);
  return {
    id: `${country}-${region}-${town}`.toLowerCase().replace(/\s+/g, '-'),
    name: town, region, country,
    branches: kids, kpis: rollup(kids),
  };
});

export const PEER_GROUPS = [...new Set(BRANCHES.map(b => b.peerGroup))];

export function getBranch(id) { return BRANCHES.find(b => b.id === id); }
export function peersOf(branch) { return BRANCHES.filter(b => b.peerGroup === branch.peerGroup && b.id !== branch.id); }

// ---------- Trend series (12-month rolling, for charts) ----------
const mkSeries = (start, drift = 0.02, noise = 0.05) => {
  const out = [];
  let v = start;
  for (let i = 0; i < 12; i++) {
    v = v * (1 + drift + (Math.random() - 0.5) * noise);
    out.push(+v.toFixed(2));
  }
  return out;
};

export const MONTHS = ['May','Jun','Jul','Aug','Sep','Oct','Nov','Dec','Jan','Feb','Mar','Apr'];

export const TRENDS = {
  groupRevenue: mkSeries(90_000_000, 0.015, 0.04),
  groupNps: mkSeries(8.6, 0.005, 0.02),
  groupSla: mkSeries(89, 0.004, 0.02),
  groupTurnover: mkSeries(9, -0.01, 0.06),
  groupCompliance: mkSeries(96, 0.003, 0.01),
};

// ---------- Insurer / contract mix ----------
export const INSURERS = [
  { name: 'Santam', jobs: 3820, slaPass: 96.8, revenueShare: 28 },
  { name: 'Discovery Insure', jobs: 2940, slaPass: 94.2, revenueShare: 22 },
  { name: 'Outsurance', jobs: 2210, slaPass: 97.1, revenueShare: 17 },
  { name: 'Hollard', jobs: 1640, slaPass: 92.4, revenueShare: 13 },
  { name: 'Old Mutual Insure', jobs: 1280, slaPass: 95.6, revenueShare: 10 },
  { name: 'Auto & General', jobs: 860, slaPass: 91.2, revenueShare: 6 },
  { name: 'Direct / Retail', jobs: 520, slaPass: 89.4, revenueShare: 4 },
];

// ---------- Per-branch phase SLA performance ----------
// Deterministic PRNG seeded from branch id so values are stable across reloads.
const xmur3 = (str) => {
  let h = 1779033703 ^ str.length;
  for (let i = 0; i < str.length; i++) {
    h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
    h = (h << 13) | (h >>> 19);
  }
  return () => {
    h = Math.imul(h ^ (h >>> 16), 2246822507);
    h = Math.imul(h ^ (h >>> 13), 3266489909);
    h ^= h >>> 16;
    return (h >>> 0) / 4294967296;
  };
};

const PHASE_DEFS = [
  { id: 'check-in',         slaMin: 15, varianceWeight: 0.6 },
  { id: 'prep',             slaMin: 20, varianceWeight: 1.2 },
  { id: 'fitment',          slaMin: 45, varianceWeight: 1.4 },
  { id: 'quality-check',    slaMin: 15, varianceWeight: 0.7 },
  { id: 'curing',           slaMin: 30, varianceWeight: 0.9 },
  { id: 'final-inspection', slaMin: 15, varianceWeight: 0.7 },
  { id: 'collection',       slaMin: 60, varianceWeight: 1.3 },
];

function withPhasePerformance(branch) {
  const rand = xmur3(branch.id);
  const branchAdh = branch.ops.slaAdherence;          // 80–100ish
  const health = (branchAdh - 70) / 30;                // 0..1 roughly
  const phasePerformance = {};
  PHASE_DEFS.forEach(({ id, slaMin, varianceWeight }) => {
    // Base actual: SLA scaled by (1 + over-run). Worse health → bigger over-run.
    // Healthy branches clamp to near-SLA; unhealthy ones get amplified variance.
    const shortfall = Math.max(0, 1 - health);
    const over = Math.pow(shortfall, 1.2) * varianceWeight * (0.5 + rand() * 0.8);
    const jitter = (rand() - 0.5) * 0.06 * varianceWeight;
    const actualAvgMin = +Math.max(1, slaMin * (1 + over + jitter)).toFixed(1);
    // Adherence: strong when actual ≈ SLA, degrades as actual exceeds SLA.
    const ratio = actualAvgMin / slaMin;
    let adherencePct = 100 - Math.max(0, ratio - 1) * 95 - rand() * 3;
    adherencePct = Math.max(40, Math.min(100, +adherencePct.toFixed(1)));
    const trend = [];
    for (let i = 0; i < 12; i++) {
      const drift = (rand() - 0.5) * 6;
      trend.push(Math.max(40, Math.min(100, +(adherencePct + drift).toFixed(1))));
    }
    phasePerformance[id] = { slaMin, actualAvgMin, adherencePct, trend };
  });
  return { ...branch, phasePerformance };
}

export const BRANCHES_WITH_PHASES = BRANCHES.map(withPhasePerformance);

export const GROUP_PHASE_AVG = PHASE_DEFS.reduce((acc, { id, slaMin }) => {
  const rows = BRANCHES_WITH_PHASES.map(b => b.phasePerformance[id]);
  const actualAvgMin = +avg(rows.map(r => r.actualAvgMin)).toFixed(1);
  const adherencePct = +avg(rows.map(r => r.adherencePct)).toFixed(1);
  const trend = Array.from({ length: 12 }, (_, i) =>
    +avg(rows.map(r => r.trend[i])).toFixed(1)
  );
  acc[id] = { slaMin, actualAvgMin, adherencePct, trend };
  return acc;
}, {});

export function getBranchWithPhases(id) {
  return BRANCHES_WITH_PHASES.find(b => b.id === id);
}

export function computeManagementInsights(branchesWithPhases, stages) {
  const stageById = Object.fromEntries(stages.map(s => [s.id, s]));
  const rows = [];
  branchesWithPhases.forEach(branch => {
    Object.entries(branch.phasePerformance).forEach(([phaseId, p]) => {
      const stage = stageById[phaseId];
      if (!stage) return;
      const highByAdh  = p.adherencePct < 80;
      const highByTime = p.actualAvgMin > p.slaMin * 1.3;
      const medByAdh   = p.adherencePct < 90;
      const medByTime  = p.actualAvgMin > p.slaMin * 1.15;
      let severity = null;
      if (highByAdh || highByTime) severity = 'high';
      else if (medByAdh || medByTime) severity = 'medium';
      if (!severity) return;
      const deltaPct = Math.round(((p.actualAvgMin - p.slaMin) / p.slaMin) * 100);
      let recommendation;
      if (severity === 'high' && (phaseId === 'fitment' || phaseId === 'prep')) {
        recommendation = 'Recommend: additional technician + targeted training';
      } else if (severity === 'high' && (phaseId === 'quality-check' || phaseId === 'final-inspection')) {
        recommendation = 'Recommend: retrain on QC checklist';
      } else if ((phaseId === 'curing' || phaseId === 'collection') && deltaPct > 15) {
        recommendation = 'Recommend: investigate workflow constraints';
      } else if (severity === 'medium') {
        recommendation = 'Recommend: coaching refresher';
      } else {
        recommendation = 'Recommend: investigate workflow constraints';
      }
      rows.push({
        branchId: branch.id,
        branchName: branch.name,
        phaseId,
        phaseName: stage.name,
        severity,
        deltaPct,
        adherencePct: p.adherencePct,
        recommendation,
      });
    });
  });
  const sevRank = { high: 0, medium: 1, low: 2 };
  rows.sort((a, b) => sevRank[a.severity] - sevRank[b.severity] || b.deltaPct - a.deltaPct);
  return rows.slice(0, 12);
}

// ---------- ISO event log (for ISO sliver + insights) ----------
export const ISO_EVENTS = [
  { id: 'NCR-2408', type: 'NCR', branch: 'Centurion', severity: 'Medium', title: 'Primer cure time not recorded on 3 jobs', status: 'Open', age: '4d', owner: 'Q. Moloi' },
  { id: 'CAPA-1127', type: 'CAPA', branch: 'Pietermaritzburg', severity: 'High', title: 'Repeat rework on Ford Ranger windscreens', status: 'Investigating', age: '2d', owner: 'S. Naidoo' },
  { id: 'AUDIT-0042', type: 'Audit', branch: 'Sandton CBD', severity: 'Info', title: 'Internal audit — QMS §8.5 pass', status: 'Closed', age: '1d', owner: 'T. van Wyk' },
  { id: 'DOC-9981', type: 'Doc Control', branch: 'Group', severity: 'Low', title: 'WI-023 superseded — v4.2 published', status: 'Published', age: '6h', owner: 'B. Khumalo' },
  { id: 'NCR-2409', type: 'NCR', branch: 'Maputo', severity: 'Medium', title: 'Calibration sticker expired — torque wrench #7', status: 'Open', age: '9h', owner: 'L. Matsinhe' },
  { id: 'CAPA-1128', type: 'CAPA', branch: 'Durban CBD', severity: 'Low', title: 'Customer signature missing on 2 job cards', status: 'Verification', age: '3d', owner: 'P. Mdluli' },
  { id: 'AUDIT-0043', type: 'Audit', branch: 'Group', severity: 'Info', title: 'External surveillance audit scheduled 2026-05-14', status: 'Scheduled', age: '—', owner: 'T. van Wyk' },
];

// ---------- Customer feedback stream ----------
export const FEEDBACK = [
  { branch: 'Sandton CBD', rating: 10, verbatim: 'Fastest windscreen replacement I have ever had.', author: 'M. Dlamini', ago: '12m' },
  { branch: 'Centurion', rating: 6, verbatim: 'Technician was late and did not explain the process.', author: 'J. Pretorius', ago: '38m' },
  { branch: 'Cape Town CBD', rating: 10, verbatim: 'Very professional. Insurer handled, I barely lifted a finger.', author: 'N. Jacobs', ago: '1h' },
  { branch: 'Umhlanga', rating: 9, verbatim: 'Great work, small delay on parts.', author: 'R. Govender', ago: '2h' },
  { branch: 'Pietermaritzburg', rating: 5, verbatim: 'Had to come back twice for a wiper issue.', author: 'S. Khoza', ago: '3h' },
];
